// Fuente única de los menús por rol, compartida por los layouts vertical y horizontal.
export * from './pharmacy.menu';
export * from './administrator.menu';
export * from './doctor.menu';
export * from './warehouse.menu';
